module.exports = __webpack_public_path__ + "img/sobre_cultura_bento_capela_05.b1efda06.png";